module.exports = __webpack_public_path__ + "static/media/memsql.e4a5e511.svg";